import React, { useState } from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
// import Header from "../components/Header"; // Header is now in MainReportsDashboard

const BLUE = [0, 0, 139];

const formOptions = {
  "Agriculture and Fishery Profile": [
    "[1] Per Agricultural Commodity",
    "[2] Per Farm Area",
    "[3] Mga Pamilyang may produkto mula sa Nipa",
    '[4] Lawak ng lupang sinasaka at mga may-ari ng lupa na "tenanted" o buwisan',
    "[5] Hayop na pangkain (Farm Animals)",
    "[6] Hayop na pambahay (Pet Animals)",
    "[7] Kagamitang pangsakahan (Agricultural Machineries)",
    "[8] Mga pamilya ng mga palaisdaan",
    "[9] Kagamitang pangingisda (Fishing Gears)",
    "[10] Kagamitang pangingisda (Fishing vessel)",
  ],
  "Disaster Risk Reduction Profile": [
    "[1] Listahan ng mga pamilya ayon sa lokasyon ng pinagtatayuan ng bahay",
    "[2] Mga pamilyang walang matatag na bahay (Without Durable House)",
    "[3] Geo-reference point ng main family",
    "[4] Geo-reference point ng extended family",
  ],
  "Environmental Sanitation": [
    "[1] Mga pamilyang walang malinis na palikuran (w/o Sanitary Toilet)",
    "[2] Mga pamilyang walang elektrisidad (w/o Electricity)",
    "[3] Mga pamilyang walang gulayan sa Bakuran (w/o Backyard Garden)",
    "[4] Mga pamilya ayon sa lebel ng pinagkukunan ng tubig (Washing/General Use)",
    "[5] Mga pamilya ayon sa lebel ng pinagkukunan ng tubig (Drinking/Cooking)",
    "[6] Mga pamilyang walang maayos na tapunan ng basura (w/o Proper Garbage Disposal)",
  ],
  "Health and Nutrition Profile": [
    "[1] Mga pamilyang nagtatanim ng halamang gamot (List of Families with medicinal plants)",
    "[2] Mga miyembro ng pamilya na may kapansanan (List of Family Member(s) with Disability)",
    "[3] Mga miyembro ng pamilya na may kapansanan ayon sa lokasyon ng bahay (List of Family Members(s) with disability according to house location)",
    "[4] Mga miyembro ng pamilya na may sakit (List of Family Member(s) with Sickness)",
    "[5] Mga Miyembro ng Pamilya na walang Health Insurance (List of Family Members without Health Insurance)",
    "[6] Mga Miyembro ng Pamilya na Mayroong Health Insurance (List of Family Members with Health Insurance)",
    "[7] Mga Pamilyang may Batang hindi gumagamit ng Iodized salt (List of Families with Children not using Iodized salt)",
    "[8] Listahan ng mga kasalukuyang Buntis (List of Pregnant Women)",
    "[9] Listahan ng mga bata edad 0-24 buwan ayon sa paraan ng pagpapakain (List of Children 0-24 monts according to feeding practices)",
    "[10] Listahan ng mga batang pinurga at hindi napurga (List of Children Dewormed/not dewormed)",
    "[11] Listahan ng pamilya na hindi kumakain nang kaunti kaysa sa nararapat",
    "[12] Listahan ng mga batang edad 0-11 buwan na walang bakuna",
    "[13] Listahan ng mga batang edad 0-11 buwan na kasalukuyang binabakunahan",
    "[14] Listahan ng mga batang edad 12-23 buwan na wala o hindi kumpleto and bakuna",
    // "[15] Listahan ng mga tao ayon sa kalagayan ng COVID Vaccination",
  ],
  "Institutional Household, Death, and Migration Profile": [
    "[1] Listahan ng mga Hindi Residente sa Barangay",
    "[2] Listahan ng mga umalis sa Barangay",
    "[3] Listahan ng mga namatay sa Barangay",
  ],
  "Socio-economic Profile": [
    "[1] Listahan ng mga pamilya (Masterlist of Families)",
    "[2a] Listahan ng mga walang pirmihang hanapbuhay (Without Regular Income) - Puno ng Pamilya",
    "[2b] Listahan ng mga walang pirmihang hanapbuhay (Without Regular Income) - Asawa ng Puno ng Pamilya",
    '[3a] Listahan ng pamilyang mababa ang "per capita income" - below food threshold',
    '[3b] Listahan ng pamilyang mababa ang "per capita income" - above food threshold but below poverty',
    "[4] Mga miyembro ng pamilya na naghahanapbuhay (List of Family Member(s) with Source of Income)",
    "[5] Mga miyembro ng pamilya na naghahanapbuhay ayon sa kurso at kita (List of Family Member(s) with Source of Income/Course/Income)",
    "[6] Mga miyembro ng pamilya na naghahanapbuhay sa ibang bansa (List of Overseas Filipino Workers",
    "[7] Listahan ng mga kabataan na hindi napasok sa paaralan (Children not attending school)",
    "[8] Mga miyembro ng pamilya na may kasanayan/kakayahan (List of Skilled Workers)",
    "[9] Mga botanteng rehistrado sa barangay edad 18 taong gulang pataas",
    "[10] Mga botanteng hindi rehistrado sa barangay edad 18 taong gulang pataas",
    "[11] Mga botanteng kabataan edad 15-17 taong gulang (List of SK Votees)",
    '[12] Mga miyembro ng pamilya na hindi naka-rehistro sa "Local Civil Registrar" (List of Unregistered Live Births at the Local Civil Registrar)',
    "[13] Mga Senior Citizen edad 60 taong gulang pataas (List of Senior Citizen)",
    "[14] Mga may-ari ng sasakyan (List of Families with Vehicles)",
    "[15] Mga pamilyang mayroong Telepono (List of Families with Telephones)",
    "[16] Mga pamilya na mayroon internet connectivity (List of Families with internet connectivity)",
    "[17] Mga miyembro ng pamilya na kasapi sa mga organisasyon (List of Family member(s) based on Membership in Organization)",
    "[18] Mga miyembro ng pamilya na Solo Parent, Widow, Separated, Annulled and Legally Separated",
  ],
  "Peace and Order Profile": [],
};

function Reports({ searchQuery, isSearchApplied, locationData }) {
  // Accept props
  // Removed local state for searchQuery and isSearchApplied

  // State for each dropdown's selected value
  const [selectedAgricultureForm, setSelectedAgricultureForm] = useState("");
  const [selectedDisasterForm, setSelectedDisasterForm] = useState("");
  const [selectedEnvironmentalForm, setSelectedEnvironmentalForm] =
    useState("");
  const [selectedHealthNutritionForm, setSelectedHealthNutritionForm] =
    useState("");
  const [selectedInstitutionalForm, setSelectedInstitutionalForm] =
    useState("");
  const [selectedSocioEconomicForm, setSelectedSocioEconomicForm] =
    useState("");
  const [selectedPeaceOrderForm, setSelectedPeaceOrderForm] = useState("");

  // handleApplySearch is removed as it's now handled by the parent component

  function formatDateToDDMMMYY(date) {
    const day = String(date.getDate()).padStart(2, '0');
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = monthNames[date.getMonth()];
    const year = String(date.getFullYear()).slice(-2); // get last two digits
    console.log(`${day}-${month}-${year}`);
    
    return `${day}-${month}-${year}`;
  }

  const getCurrentDate = () => {
    const currentDate = new Date();
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    const formattedDate = currentDate.toLocaleDateString("en-US", options);
    return formattedDate;
  };

  const generateForm = async (reportType, formName, locationData) => {
    const { regionName, provinceName, municipalName, barangayName } = locationData;
    let doc;
    let fetchedData = {};
    const apiTypeForm = formOptions[reportType].indexOf(formName) + 1;
    const apiTypeReport = Object.keys(formOptions).indexOf(reportType) + 1;
    let baseUrl = `${process.env.REACT_APP_API_URL}/api/locations/api/reports/reports`

    // initialize doc file
      doc = new jsPDF("portrait", "pt", "A4");

    // get doc's dimensions
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const padding = 70;

    if (apiTypeReport && apiTypeForm) {
      console.log(apiTypeReport, apiTypeForm);
      try {
        const location = `${provinceName}_${municipalName}_${barangayName}`
        const apiUrl = `${baseUrl}?location=${encodeURIComponent(location)}&report=${apiTypeReport}&form=${apiTypeForm}`;
        const response = await fetch(apiUrl, {
          method: 'GET',
          headers: {
            'x-api-key': process.env.REACT_APP_API_KEY
          }
        });
        const data = await response.json();
        if (Array.isArray(data) && data.length > 0) {
          fetchedData = data; // Assuming it returns an array with one object
          // console.log(fetchedData);
          
        } else {
          console.warn(`API for ${formName} returned an empty array or non-array data. Data received:`, data);
          // Default empty fetchedData if no data
        }
      } catch (error) {
        console.error(`Error fetching data for ${formName}:`, error);
        // Default empty fetchedData on error
      }
    }

    if (reportType === "Agriculture and Fishery Profile") {
      if (formName === "[1] Per Agricultural Commodity") {
        doc.setFontSize(12);
        doc.setFont("times", "bold");
        doc.text(
          "Listahan ng mga pamilya ayon sa pananim/produktong pang agrikultura\n(List of Families Per Commodity)",
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Pangalan ng Puno ng Pamilya",
            "Uri ng Pananim/Produkto",
            "Lawak (hectares)",
            "Bilang ng puno",
            "Lugar",
          ],
          barangayName && municipalName && provinceName ? [{content: `Barangay: ${barangayName}, ${municipalName}, ${provinceName}`, colSpan: 7}] : 
          municipalName && provinceName ? [{content: `Municipality: ${municipalName}, ${provinceName}`, colSpan: 7}] :
          [{content: `Province: ${provinceName}`, colSpan: 7}]
          ,
        ];

        const parseData = () => {
          if (Object.keys(fetchedData).length === 0) return [];
          const items = [];
          let prev_head = '';
          for (let item of fetchedData) {
            if (item.fullname !== prev_head) {
              items.push([
                {content: item.purok},
                {content: item.house_no},
                {content: item.fullname},
                {content: item.tanim},
                {content: item.hectares},
                {content: item.tree_count},
                {content: item.location}
              ]);
              prev_head = item.fullname;
            } else {
              items.push([
                {content: ''},
                {content: ''},
                {content: ''},
                {content: item.tanim},
                {content: item.hectares},
                {content: item.tree_count},
                {content: item.location}
              ]);
            }
          }

          return items;
        }

        const body = [
          ...parseData()
        ];

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {bottom: padding + 20},
          styles: {
            fontSize: 10,
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            font: 'times',
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10, 
            cellPadding: {
              bottom: 12,
            }
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.08, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.08, halign: "center" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.20, halign: "center" }, // Pangalan ng puno ng Pamilya
            3: { cellWidth: pageWidth * 0.20, halign: "center" }, // Uri ng pananim o produkto
            3: { cellWidth: pageWidth * 0.08, halign: "center" }, // Lawak (hectares)
            4: { cellWidth: pageWidth * 0.08, halign: "center" }, // Bilang ng puno
            5: { cellWidth: pageWidth * 0.12, halign: "center" }, // Lugar
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211, 211, 211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 8,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === "[2] Per Farm Area") {
        doc.setFontSize(12);
        doc.setFont("times", "bold");
        doc.text(
          "Listahan ng mga pamilya ayon sa laki ng bukid\n(List of Families per Farm Area and Ownership)",
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Pangalan ng Puno ng Pamilya",
            "Total Farm Area",
            "Status of farm ownership",
            "Location of farm",
          ],
          barangayName && municipalName && provinceName ? [{content: `Barangay: ${barangayName}, ${municipalName}, ${provinceName}`, colSpan: 7}] : 
          municipalName && provinceName ? [{content: `Municipality: ${municipalName}, ${provinceName}`, colSpan: 7}] :
          [{content: `Province: ${provinceName}`, colSpan: 7}]
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return ([
            {content: item.purok},
            {content: item.house_no},
            {content: item.fullname},
            {content: item.area_hectares},
            {content: item.IDkalagayanlupa},
            {content: item.location}
          ])
        }) : [];

        autoTable(doc, {
          startY: 120,
          head: head,
          body: body,
          theme: "grid",
          margin: {bottom: padding + 20},
          styles: {
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.15, halign: "center" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.15, halign: "center" }, // Pangalan ng puno ng Pamilya
            3: { cellWidth: pageWidth * 0.1, halign: "center" }, // Total Farm Area,
            4: { cellWidth: pageWidth * 0.15, halign: "center" }, // Status of Ownership,
            5: { cellWidth: pageWidth * 0.2, halign: "center" }, // Location of Farm
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.colSpan = 6;
              data.cell.styles.fillColor = [211, 211, 211]; // Light blue background
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 8,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === "[3] Mga Pamilyang may produkto mula sa Nipa") {
        doc.setFontSize(12);
        doc.setFont("times", "bold");
        doc.text(
          "Listahan ng mga pamilya ayon sa produktong mula sa Nipa\n(List of Families with products derived from Nipa)",
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan ng Puno ng Pamilya",
            "Uri ng Produkto",
            "Volume",
            "Lugar",
          ],
          barangayName && municipalName && provinceName ? [{content: `Barangay: ${barangayName}, ${municipalName}, ${provinceName}`, colSpan: 7}] : 
          municipalName && provinceName ? [{content: `Municipality: ${municipalName}, ${provinceName}`, colSpan: 7}] :
          [{content: `Province: ${provinceName}`, colSpan: 7}]
        ];

        const sampleBody = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return (
            [
              {content: item.purok}, 
              {content: item.house_no}, 
              {content: item.street}, 
              {content: item.fullname}, 
              {content: item.product}, 
              {content: item.quantity}, 
              {content: item.location}
            ]
          )
        }) : [];

        autoTable(doc, {
          startY: 120,
          head: head,
          body: sampleBody,
          theme: "grid",
          margin: {bottom: padding + 20},
          styles: {
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "left" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "center" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.15, halign: "center" }, // Street
            3: { cellWidth: pageWidth * 0.15, halign: "center" }, // Pangalan ng puno ng Pamilya
            4: { cellWidth: pageWidth * 0.1, halign: "center" }, // Uri ng produkto
            5: { cellWidth: pageWidth * 0.1, halign: "center" }, // Volume
            6: { cellWidth: pageWidth * 0.15, halign: "center" }, // Lugar
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.colSpan = 7;
              data.cell.styles.fillColor = [211, 211, 211]; // Light blue background
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 8,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === '[4] Lawak ng lupang sinasaka at mga may-ari ng lupa na "tenanted" o buwisan') {
        doc.setFontSize(12);
        doc.setFont("times", "bold");
        doc.text(
          'Listahan ng mga pamilya ayon sa kabuuang lupang sinasaka at may-ari\nng lupang "tenanted" o buwisan\n(List of Families Per Farm Land Area and Owner of Tenanted Farm Lots)',
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 100, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Pangalan ng Puno ng Pamilya",
            "Pangalan ng may-ari ng lupang sinasaka",
            "Lugar",
            "Lawak (hectares)",
          ],
        ];

        const parseData = () => {
          if (Object.keys(fetchedData).length === 0) return [];
          const items = [];
          let prev_barangay;
          for (let item of fetchedData) {
            if (item.location !== prev_barangay) {
              prev_barangay = item.location;
              items.push([
                {
                  content: "Barangay: ",
                  styles: {
                    fontStyle: "bolditalic",
                    cellPadding: { top: 8, bottom: 8, left: 2, right: 2 },
                  },
                },
                {
                  content: item.location,
                  colSpan: 5,
                  styles: {
                    halign: "left",
                    cellPadding: { top: 8, bottom: 8, left: 2, right: 2 },
                  },
                },
              ],)
              items.push([
                {content: item.purok},
                {content: item.house_no},
                {content: item.fullname},
                {content: item.owner},
                {content: item.location},
                {content: item.area_hectares}
              ]);
            } else if (item.location === prev_barangay) {
              items.push([
                {content: item.purok},
                {content: item.house_no},
                {content: item.fullname},
                {content: item.owner},
                {content: item.location},
                {content: item.area_hectares}
              ]);
            }
          }
          return items;
        }

        const body = [
          ...parseData()
        ]

        autoTable(doc, {
          startY: 120,
          head: head,
          body: body,
          theme: "grid",
          margin: {bottom: padding + 20},
          styles: {
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "center" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.15, halign: "center" }, // Pangalan ng puno ng Pamilya
            3: { cellWidth: pageWidth * 0.15, halign: "center" }, // Pangalan ng may-ari ng lupang sinasaka
            4: { cellWidth: pageWidth * 0.25, halign: "center" }, // Lugar
            5: { cellWidth: pageWidth * 0.1, halign: "center" }, // Lawak
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineWidth = {
                bottom: 3
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === "[5] Hayop na pangkain (Farm Animals)") {
        doc.setFontSize(12);
        doc.setFont("times", "bold");
        doc.text(
          'Listahan ng pamilya na may alagang hayop\n(List of Families Raising Farm Animals)',
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan ng Puno ng Pamilya",
            "Uri ng Hayop",
            "Bilang",
          ],
          [ 
            { content: `${barangayName ? 'Barangay: ' : municipalName ? 'Municipality: ' : 'Province: '}`, colSpan: 2, styles: {}},
            { content: `${barangayName ? `${barangayName},` : ''} ${municipalName ? `${municipalName},` : ''} ${provinceName}`, colSpan: 4, styles: {halign: 'left'}}
          ],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return ([
            {content: item.purok},
            {content: item.house_no},
            {content: item.street},
            {content: item.fullname},
            {content: item.Hayop},
            {content: item.quantity}
          ])
        }) : [];

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {bottom: padding + 20},
          styles: {
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
            cellPadding: {
              bottom: 12,
            }
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.13, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "center" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.13, halign: "center" }, // Street
            3: { cellWidth: pageWidth * 0.15, halign: "center" }, // Pangalan ng puno ng Pamilya
            4: { cellWidth: pageWidth * 0.24, halign: "center" }, // Uri ng hayop
            5: { cellWidth: pageWidth * 0.1, halign: "center" }, // Bilang
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211, 211, 211]; // Light blue background
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 8,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === "[6] Hayop na pambahay (Pet Animals)") {
        doc.setFontSize(12);
        doc.setFont("times", "bold");
        doc.text(
          'Listahan ng pamilya na nag-aalaga ng iba pang hayop\n(List of Families With Pet Animals)',
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan ng Puno ng Pamilya",
            "Uri ng Hayop",
            "Bilang",
          ],
          [ 
            { content: `${barangayName ? 'Barangay: ' : municipalName ? 'Municipality: ' : 'Province: '}`, colSpan: 2, styles: {}},
            { content: `${barangayName ? `${barangayName},` : ''} ${municipalName ? `${municipalName},` : ''} ${provinceName}`, colSpan: 4, styles: {halign: 'left'}}
          ],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return ([
            {content: item.purok},
            {content: item.house_no},
            {content: item.street},
            {content: item.fullname},
            {content: item.Pet},
            {content: item.quantity}
          ])
        }) : [];

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {bottom: padding + 20},
          styles: {
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            font: 'times',
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10, 
            cellPadding: {
              bottom: 12,
            }
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.11, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "center" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.15, halign: "center" }, // Street
            3: { cellWidth: pageWidth * 0.15, halign: "center" }, // Pangalan ng puno ng Pamilya
            4: { cellWidth: pageWidth * 0.24, halign: "center" }, // Uri ng hayop
            5: { cellWidth: pageWidth * 0.1, halign: "center" }, // Bilang
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211, 211, 211]; // Light blue background
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 8,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === "[7] Kagamitang pangsakahan (Agricultural Machineries)") {
        doc.setFontSize(12);
        doc.setFont("times", "bold");
        doc.text(
          'Mga Pamilya may pagmamay-ari ng mga kagamitang pangsakahan\n(List of Families with Agricultural Machineries)',
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan ng Puno ng Pamilya",
            "Uri ng Kagamitan",
            "Bilang",
          ],
          [ 
            { content: `${barangayName ? 'Barangay: ' : municipalName ? 'Municipality: ' : 'Province: '}`, colSpan: 2, styles: {}},
            { content: `${barangayName ? `${barangayName},` : ''} ${municipalName ? `${municipalName},` : ''} ${provinceName}`, colSpan: 4, styles: {halign: 'left'}}
          ],
        ];


        const parseData = () => {
          if (Object.keys(fetchedData).length === 0) return []
          const items = [];
          let prev_head;
          for (let item of fetchedData) {
            if (item.fullname !== prev_head) {
              items.push([
                {content: item.purok},
                {content: item.house_no},
                {content: item.street},
                {content: item.fullname},
                {content: item.machinery},
                {content: item.quantity}
              ])
              prev_head = item.fullname;
            } else {
              items.push([
                {content: ''},
                {content: ''},
                {content: ''},
                {content: ''},
                {content: item.machinery},
                {content: item.quantity}
              ])
            }
          }
          return items;
        }
        
        const body = [
            ...parseData()
        ];

        

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {bottom: padding + 20},
          styles: {
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            font: 'times',
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10, 
            cellPadding: {
              bottom: 12,
            }
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.11, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "center" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.15, halign: "center" }, // Street
            3: { cellWidth: pageWidth * 0.15, halign: "center" }, // Pangalan ng puno ng Pamilya
            4: { cellWidth: pageWidth * 0.24, halign: "center" }, // Uri ng kagamitan
            5: { cellWidth: pageWidth * 0.1, halign: "center" }, // Bilang
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211, 211, 211]; // Light gray background
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 8,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === "[8] Mga pamilya ng mga palaisdaan") {
        doc.setFontSize(12);
        doc.setFont("times", "bold");
        doc.text(
          'Listahan ng mga pamilya na may palaisdaan\n(List of Families Engaged in Fishery Production)',
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan ng Puno ng Pamilya",
            "Kalagayan sa pagmamay-ari ng",
            "Uri ng Palaisdaan",
            "Uri ng isda",
            "Laki ng Fishpond/pen at Blg ng isda",
            "Lugar ng palaisdaan"
          ],
          [ 
            { content: `${barangayName ? 'Barangay: ' : municipalName ? 'Municipality: ' : 'Province: '}`, colSpan: 2, styles: {}},
            { content: `${barangayName ? `${barangayName},` : ''} ${municipalName ? `${municipalName},` : ''} ${provinceName}`, colSpan: 6, styles: {halign: 'left'}}
          ],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return (
            [
              {content: item.purok},
              {content: item.house_no},
              {content: item.street},
              {content: item.fullname},
              {content: item.fishery_condition},
              {content: item.fishery_type},
              {content: item.fish_type},
              {content: `${item.fishery_total_area} / ${item.quantity}`},
              {content: item.fishery_location}
            ]
          )
        }) : []


        autoTable(doc, {
          startY: 70,
          head: head,
          body: body,
          theme: "grid",
          margin: {bottom: padding + 20},
          styles: {
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            font: 'times',
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "start",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10, 
            cellPadding: {
              bottom: 12,
              left: 2,
              right: 2,
            }
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.05, halign: "center" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.1, halign: "center" }, // Street
            3: { cellWidth: pageWidth * 0.1, halign: "center" }, // Pangalan ng puno ng Pamilya
            4: { cellWidth: pageWidth * 0.1, halign: "center" }, // Kalagayan sa pagmamay-ari ng
            5: { cellWidth: pageWidth * 0.1, halign: "center" }, // Uri ng palaisdaan
            6: { cellWidth: pageWidth * 0.1, halign: "center" }, // Uri ng isda
            7: { cellWidth: pageWidth * 0.12, halign: "center" }, // Laki ng Fishpond, pen at Blg ng isda
            8: { cellWidth: pageWidth * 0.14, halign: "center" }, // Lugar ng palaisdaan
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 8,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === "[9] Kagamitang pangingisda (Fishing Gears)") {
        doc.setFontSize(12);
        doc.setFont("times", "bold");
        doc.text(
          'List of Families who own fishing gears',
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 65, { align: "center" });

        doc.setFont("times", "bolditalic");
        doc.text(
          `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, 
          50, 
          105
        );

        const head = [
          [
            "Purok",
            "House Number",
            "Name",
            "Type of Fishing Gear",
            "Bilang"
          ],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return ([
            {content: item.purok},
            {content: item.house_no},
            {content: item.fullname},
            {content: item.gear_type},
            {content: item.quantity}
          ])
        }) : []

        autoTable(doc, {
          startY: 110,
          head: head,
          body: body,
          theme: "grid",
          margin: {bottom: padding + 20},
          styles: {
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            font: 'times',
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "start",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10, 
            cellPadding: {
              top: 12,
              bottom: 12,
            }
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.15, halign: "center" }, // House Number
            2: { cellWidth: pageWidth * 0.30, halign: "center" }, // Name
            3: { cellWidth: pageWidth * 0.2, halign: "center" }, // Type of Fishing Gear
            4: { cellWidth: pageWidth * 0.1, halign: "center" }, // Bilang
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.cellPadding = {
                top: 5,
                bottom: 8,
              };
              data.cell.styles.lineWidth = {
                top: 2,
                bottom: 3
              };
              data.cell.styles.lineColor = [211, 211, 211];
            }
          },
        });
        
      } else if (formName === "[10] Kagamitang pangingisda (Fishing vessel)") {
        doc.setFontSize(12);
        doc.setFont("times", "bold");
        doc.text(
          'List of Families with fishing vessels',
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 65, { align: "center" });

        doc.setFont("times", "bolditalic");
        doc.text(`${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, 50, 105);

        const head = [
          [
            "Purok",
            "House Number",
            "Street",
            "Name",
            "Uri",
            "No."
          ],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return ([
            {content: item.purok},
            {content: item.house_no},
            {content: item.street},
            {content: item.fullname},
            {content: item.vessel_type},
            {content: item.quantity}
          ])
        }) : []

        autoTable(doc, {
          startY: 110,
          head: head,
          body: body,
          theme: "grid",
          margin: {bottom: padding + 20},
          styles: {
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            font: 'times',
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "start",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10, 
            cellPadding: {
              top: 12,
              bottom: 12,
            }
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.15, halign: "center" }, // House Number
            1: { cellWidth: pageWidth * 0.15, halign: "center" }, // Street
            2: { cellWidth: pageWidth * 0.20, halign: "center" }, // Name
            3: { cellWidth: pageWidth * 0.2, halign: "center" }, // Uri
            4: { cellWidth: pageWidth * 0.1, halign: "center" }, // Bilang
          },
        });

        doc.setLineWidth(3);
        doc.setDrawColor(211, 211, 211);
        doc.line(40, 120, pageWidth - 50, 120);
        doc.line(40, 145, pageWidth - 50, 145);
      }
    } else if (reportType === "Disaster Risk Reduction Profile") {
      // reports
      if (formName === "[1] Listahan ng mga pamilya ayon sa lokasyon ng pinagtatayuan ng bahay") {
        doc.setFontSize(12);
        doc.setFont("times", "bold");
        doc.text(
          "Listahan ng pamilya ayon sa lokasyon ng bahay\n(List of Families according to residential location)",
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Numero ng Bahay",
            "Street",
            "Pangalan ng Puno ng Pamilya",
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 3}],
        ];

        const customBodyStyle = (leftPadding) => {
          return {
            halign: "left", 
            fontStyle: "bold", 
            cellPadding: {
              top: 5,
              right: 5,
              bottom: 5,
              left: leftPadding
            }
          }
        } 

        const parseData = () => {
          if (Object.keys(fetchedData).length === 0) return [];
          const items = [];
          let prev_purok = '';
          let prev_eco = '';
          let prev_dist = '';
          for (let item of fetchedData) {
            if (item.purok !== prev_purok) {
              items.push([
                {content: `Purok: ${item.purok}`, styles: customBodyStyle(10), colSpan: 3}
              ]);
              prev_purok = item.purok; 
              prev_eco = '';
              prev_dist = '';
            }

            if (item.location !== prev_eco) {
              items.push([
                {content: item.location, styles: customBodyStyle(30), colSpan: 3}
              ])
              prev_eco = item.location;
              prev_dist = '';
            }

            if (item.residential !== prev_dist) {
              items.push([
                  {content: item.residential, styles: customBodyStyle(50), colSpan: 3}
              ]);
              prev_dist = item.residential;
            }

            items.push([
              {content: item.house_no},
              {content: item.street},
              {content: item.fullname, styles: {halign: "left"}}
            ])
          }
          return items;
        }

        const body = [
          ...parseData()
        ]

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {bottom: padding + 20},
          styles: {
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.15, halign: "left" }, // Numero ng bahay
            1: { cellWidth: pageWidth * 0.3, halign: "center" }, // Street
            2: { cellWidth: pageWidth * 0.3, halign: "center" }, // Pangalan ng puno ng Pamilya
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === "[2] Mga pamilyang walang matatag na bahay (Without Durable House)") {
        doc.setFontSize(12);
        doc.setFont("times", "bold");
        doc.text(
          "Listahan ng pamilya na walang matibay na bahay\n(List of Families Without Durable House)",
          pageWidth / 2,
          50,
          { align: "center" }
        )

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan ng Puno ng Pamilya",
            "Uri ng Yari"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 3}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return ([
            {content: item.purok},
            {content: item.house_no},
            {content: item.street},
            {content: item.fullname},
            {content: item.value}
          ])
        }) : []

        autoTable(doc, {
          startY: 90,
          head: head,
          body: body,
          theme: "grid",
          margin: {bottom: padding + 20},
          styles: {
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "center" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.2, halign: "center" }, // Street
            3: { cellWidth: pageWidth * 0.15, halign: "center" }, // Pangalan ng puno ng pamilya
            4: { cellWidth: pageWidth * 0.3, halign: "center" } // Uri ng yari

          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211, 211, 211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === "[3] Geo-reference point ng main family") {
        const head = [
          [
            "HeadID",
            "House Number",
            "Street",
            "Purok",
            "Headname",
            "LAT",
            "LONG"
          ],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return [
            item.headID,
            item.house_no,
            item.street,
            item.purok,
            item.fullname,
            item.latitude,
            item.longitude
          ]
        }) : []

        autoTable(doc, {
          startY: 70,
          head: head,
          body: body,
          theme: "grid",
          margin: {bottom: padding + 20},
          styles: {
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 1,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 1,
            lineColor: [0, 0, 0],
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Head ID
            1: { cellWidth: pageWidth * 0.1, halign: "center" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.15, halign: "center" }, // Street
            3: { cellWidth: pageWidth * 0.15, halign: "center" }, // Purok
            4: { cellWidth: pageWidth * 0.15, halign: "center" }, // Headname
            5: { cellWidth: pageWidth * 0.1, halign: "center" }, // LAT
            6: { cellWidth: pageWidth * 0.1, halign: "center" } // LONG

          }
        })
      } else if (formName === "[4] Geo-reference point ng extended family") {
        const head = [
          [
            "HeadID",
            "House Number",
            "Street",
            "Purok",
            "Headname",
            "LAT",
            "LONG"
          ],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return [
            item.headID,
            item.house_no,
            item.street,
            item.purok,
            item.fullname,
            item.latitude,
            item.longitude
          ]
        }) : [];

        autoTable(doc, {
          startY: 70,
          head: head,
          body: body,
          theme: "grid",
          margin: {bottom: padding + 20},
          styles: {
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 1,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 1,
            lineColor: [0, 0, 0],
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Head ID
            1: { cellWidth: pageWidth * 0.1, halign: "center" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.15, halign: "center" }, // Street
            3: { cellWidth: pageWidth * 0.15, halign: "center" }, // Purok
            4: { cellWidth: pageWidth * 0.15, halign: "center" }, // Headname
            5: { cellWidth: pageWidth * 0.1, halign: "center" }, // LAT
            6: { cellWidth: pageWidth * 0.1, halign: "center" } // LONG

          }
        })
      }
    } else if (reportType === "Environmental Sanitation") {
      // reports
      if (formName === "[1] Mga pamilyang walang malinis na palikuran (w/o Sanitary Toilet)") {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng mga pamilya na walang sarili o maayos na palikuran\n(List of Families/Household Heads Without Sanitary Toilet)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan ng Puno ng Pamilya",
            "Uri ng Palikuran"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 5}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return (
            [
              {content: item.purok}, 
              {content: item.house_no}, 
              {content: item.street}, 
              {content: item.fullname, styles: {halign: "left"}}, 
              {content: item.palikuran, styles: {halign: "left"}}]
          )
        }) : [];

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {bottom: padding + 20},
          styles: {
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "center" }, // Numero ng bahay
            2: { cellWidth: pageWidth * 0.15, halign: "center" }, // Street
            3: { cellWidth: pageWidth * 0.25, halign: "center" }, // Pangalan ng puno ng pamilya
            4: { cellWidth: pageWidth * 0.2, halign: "center" }, // Uri ng palikuran
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === "[2] Mga pamilyang walang elektrisidad (w/o Electricity)") {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng pamilya na walang elektrisidad\n(List of Families Without Electrictiy)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan ng Puno ng Pamilya",
            "Pinagkukunan ng Enerhiya"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 5}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return (
            [
              {content: item.purok}, 
              {content: item.house_no}, 
              {content: item.street}, 
              {content: item.fullname, styles: {halign: "left"}}, 
              {content: item.value, styles: {halign: "left"}}
            ]
          )
        }) : [];

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {bottom: padding + 20},
          styles: {
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "center" }, // Numero ng bahay
            2: { cellWidth: pageWidth * 0.15, halign: "center" }, // Street
            3: { cellWidth: pageWidth * 0.25, halign: "center" }, // Pangalan ng puno ng pamilya
            4: { cellWidth: pageWidth * 0.2, halign: "center" }, // Uri ng palikuran
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });

      } else if (formName === "[3] Mga pamilyang walang gulayan sa Bakuran (w/o Backyard Garden)") {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng pamilya na walang halamanan sa Bakuran\n(List of Families Without Backyard Garden)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan ng Puno ng Pamilya",
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 4}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return (
            [
              {content: item.purok}, 
              {content: item.house_no}, 
              {content: item.street}, 
              {content: item.fullname, styles: {halign: "left"}}
            ]
          )
        }) : [];

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {bottom: padding + 20},
          styles: {
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.15, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.15, halign: "center" }, // Numero ng bahay
            2: { cellWidth: pageWidth * 0.2, halign: "center" }, // Street
            3: { cellWidth: pageWidth * 0.3, halign: "left" }, // Pangalan ng puno ng pamilya
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === "[4] Mga pamilya ayon sa lebel ng pinagkukunan ng tubig (Washing/General Use)") {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng pamilya ayon sa lebel ng pinagkukunan ng tubig(General use)\n(List of Families according to Level of Water Source - General Use)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan ng Puno ng Pamilya",
            "Pinagkukunan ng Tubig"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 4}],
        ];

        const bodies = [];
        let body = [];
        let prev_level = '';
        if (Object.keys(fetchedData).length !== 0) {
          for (const item of fetchedData) {
            if (item.category !== prev_level) {
              if (body.length !== 0) {
                bodies.push(body);
                body = []
              }
              body.push(
                [{content: item.category, colSpan: 5, styles: {fontStyle: "bolditalic"}}]
              );
              prev_level = item.category
            }
            body.push(
              [
                {content: item.purok}, 
                {content: item.house_no}, 
                {content: item.street}, 
                {content: item.fullname, styles: {halign: "left"}}, 
                {content: item.source_type}
              ]
            )
          }
        }
        

        bodies.forEach((item, index) => {
          autoTable(doc, {
            startY: index === 0 ? 100 : 70,
            head: head,
            body: item,
            theme: "grid",
            margin: {bottom: padding + 20},
            styles: {
              fontSize: 10, // Increased font size by 2 (from 8 to 10)
              cellPadding: 2,
              overflow: "linebreak",
              lineWidth: 0,
              lineColor: [0, 0, 0],
              textColor: [0, 0, 0],
            },
            headStyles: {
              fillColor: [255, 255, 255],
              textColor: [0, 0, 0],
              halign: "center",
              valign: "middle",
              lineWidth: 0,
              lineColor: [0, 0, 0],
              fontSize: 10, // Increased font size by 2 (from 8 to 10)
            },
            columnStyles: {
              0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
              1: { cellWidth: pageWidth * 0.1, halign: "center" }, // Numero ng bahay
              2: { cellWidth: pageWidth * 0.2, halign: "center" }, // Street
              3: { cellWidth: pageWidth * 0.2, halign: "left" }, // Pangalan ng puno ng pamilya
              4: { cellWidth: pageWidth * 0.2, halign: "center"}, //Pinagkukunan ng tubig
            },
            didParseCell: function (data) {
              // Only apply to the first column of the Barangay row (row index 1)
              if (data.section === "head" && data.row.index === 1) {
                data.cell.styles.fillColor = [211,211,211];
                data.cell.styles.halign = "left";
                data.cell.styles.cellPadding = {
                  top: 6,
                  right: 4,
                  bottom: 6,
                  left: 5,
                };
                data.cell.styles.lineWidth = {
                  top: 2
                };
                data.cell.styles.lineColor = BLUE;
              }
            },
          });
    
          if (index !== bodies.length - 1) {
            doc.addPage();
          }
        })
      } else if (formName === "[5] Mga pamilya ayon sa lebel ng pinagkukunan ng tubig (Drinking/Cooking)") {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng pamilya ayon sa lebel ng pinagkukunan ng tubig(Drinking and Cooking)\n(List of Families according to Level of Water Source - Drinking and Cooking)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan ng Puno ng Pamilya",
            "Pinagkukunan ng Tubig"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 4}],
        ];

        const bodies = [];
        let body = [];
        let prev_level = '';
        if (Object.keys(fetchedData).length !== 0) {
          for (const item of fetchedData) {
            if (item.category !== prev_level) {
              if (body.length !== 0) {
                bodies.push(body);
                body = []
              }
              body.push(
                [{content: item.category, colSpan: 5, styles: {fontStyle: "bolditalic"}}]
              );
              prev_level = item.category
            }
            body.push(
              [
                {content: item.purok}, 
                {content: item.house_no}, 
                {content: item.street}, 
                {content: item.fullname, styles: {halign: "left"}}, 
                {content: item.source_type}
              ]
            )
          }
        }

        bodies.forEach((item, index) => {
          autoTable(doc, {
            startY: index === 0 ? 100 : 70,
            head: head,
            body: item,
            theme: "grid",
            margin: {bottom: padding + 20},
            styles: {
              fontSize: 10, // Increased font size by 2 (from 8 to 10)
              cellPadding: 2,
              overflow: "linebreak",
              lineWidth: 0,
              lineColor: [0, 0, 0],
              textColor: [0, 0, 0],
            },
            headStyles: {
              fillColor: [255, 255, 255],
              textColor: [0, 0, 0],
              halign: "center",
              valign: "middle",
              lineWidth: 0,
              lineColor: [0, 0, 0],
              fontSize: 10, // Increased font size by 2 (from 8 to 10)
            },
            columnStyles: {
              0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
              1: { cellWidth: pageWidth * 0.1, halign: "center" }, // Numero ng bahay
              2: { cellWidth: pageWidth * 0.2, halign: "center" }, // Street
              3: { cellWidth: pageWidth * 0.2, halign: "left" }, // Pangalan ng puno ng pamilya
              4: { cellWidth: pageWidth * 0.2, halign: "center"}, //Pinagkukunan ng tubig
            },
            didParseCell: function (data) {
              // Only apply to the first column of the Barangay row (row index 1)
              if (data.section === "head" && data.row.index === 1) {
                data.cell.styles.fillColor = [211,211,211];
                data.cell.styles.halign = "left";
                data.cell.styles.cellPadding = {
                  top: 6,
                  right: 4,
                  bottom: 6,
                  left: 5,
                };
                data.cell.styles.lineWidth = {
                  top: 2
                };
                data.cell.styles.lineColor = BLUE;
              }
            },
          });
          
          if (index !== bodies.length - 1) {
            doc.addPage();
          }
        })
      } else if (formName === "[6] Mga pamilyang walang maayos na tapunan ng basura (w/o Proper Garbage Disposal)") {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng pamilya na walang maayos na pagtatapon ng Basura\n(List of Families Without Proper Garbage Disposal)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan ng Puno ng Pamilya",
            "Paraan ng Pagtatapon ng Basura"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 4}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return ([
            {content: item.purok},
            {content: item.house_no},
            {content: item.street},
            {content: item.fullname},
            {content: item.method}
          ])
        }) : [];

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {bottom: padding + 20},
          styles: {
            fontSize: 10, 
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "center" }, // Numero ng bahay
            2: { cellWidth: pageWidth * 0.2, halign: "center" }, // Street
            3: { cellWidth: pageWidth * 0.2, halign: "left" }, // Pangalan ng puno ng pamilya
            4: { cellWidth: pageWidth * 0.2, halign: "center"}, //Pinagkukunan ng tubig
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      }
    } else if (reportType === "Health and Nutrition Profile") {
      // reports
      if (formName === "[1] Mga pamilyang nagtatanim ng halamang gamot (List of Families with medicinal plants)") {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Mga Pamilya na nagtatanim ng halamang gamot\n(List of Families With Halamang Gamot)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan ng Puno ng Pamilya",
            "Uri ng Halamang Gamot"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 4}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return (
             [
              {content: item.purok}, 
              {content: item.house_no}, 
              {content: item.street}, 
              {content: item.fullname}, 
              {content: item.TanimHGubat}
            ]
          )
        }) : []

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {bottom: padding + 20},
          styles: {
            fontSize: 10,
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "center" }, // Numero ng bahay
            2: { cellWidth: pageWidth * 0.2, halign: "center" }, // Street
            3: { cellWidth: pageWidth * 0.2, halign: "left" }, // Pangalan ng puno ng pamilya
            4: { cellWidth: pageWidth * 0.2, halign: "center"}, //Pinagkukunan ng tubig
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === "[2] Mga miyembro ng pamilya na may kapansanan (List of Family Member(s) with Disability)") {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Mga pangalan na may kapansanan\n(List of Family Members With Disability)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan",
            "Uri ng Kapansanan",
            "PWD ID",
            "Edad",
            "Gender"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 4}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return (
            [
              {content: item.purok}, 
              {content: item.house_no}, 
              {content: item.street}, 
              {content: item.fullname}, 
              {content: item.kapansanan}, 
              {content: item.pwd_id}, 
              {content: item.age}, 
              {content: item.sex}
            ]
          )
        }) : []

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {bottom: padding + 20},
          styles: {
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.08, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "center" }, // Numero ng bahay
            2: { cellWidth: pageWidth * 0.08, halign: "center" }, // Street
            3: { cellWidth: pageWidth * 0.15, halign: "left" }, // Pangalan
            4: { cellWidth: pageWidth * 0.15, halign: "left"}, // Uri ng Kapansanana
            5: { cellWidth: pageWidth * 0.15, halign: "center" }, // PWD ID
            6: { cellWidth: pageWidth * 0.08, halign: "center" }, // Edad
            7: { cellWidth: pageWidth * 0.08, halign: "center"}, // Gender
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === "[3] Mga miyembro ng pamilya na may kapansanan ayon sa lokasyon ng bahay (List of Family Members(s) with disability according to house location)") {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng miyembro ng pamilya na may kapansanan ayon sa lokasyon ng bahay\n(List of Family Members With Disabilities according to residential location)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Numero ng Bahay",
            "Street",
            "Pangalan Puno ng Pamilya",
            "Kapansanan",
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 4}],
        ];

        const parseData = () => {
          if (Object.keys(fetchedData).length === 0) return [];
          let prev_purok = ""
          let prev_dist = ""
          const items = [];
          for (let item of fetchedData) {
            if (item.purok !== prev_purok) {
              items.push(
                [{content: `Purok ${item.purok}`, colSpan: 4, styles: {fontStyle: "bold", cellPadding: {left: 5, top: 5, bottom: 5}}}]
              )
              prev_purok = item.purok; 
              prev_dist = "";
            }

            if (item.location !== prev_dist) {
              items.push(
                [{content: item.location, colSpan: 4, styles: {fontStyle: "bold", cellPadding: {left: 30, top: 5, bottom: 5}}}]
              );
              prev_dist = item.location;
            }

            items.push(
              [
                {content: item.house_no}, 
                {content: item.street}, 
                {content: item.fullname}, 
                {content: item.kapansanan}
              ],
            )
          }
          return items;
        }

        const body = [
          ...parseData()
        ]

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 70, bottom: padding + 20},
          styles: {
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "left" }, // Numero ng bahay
            1: { cellWidth: pageWidth * 0.15, halign: "center" }, // Street
            2: { cellWidth: pageWidth * 0.25, halign: "left" }, // Puno ng pamilya
            3: { cellWidth: pageWidth * 0.25, halign: "left" }, // Kapansanan
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === "[4] Mga miyembro ng pamilya na may sakit (List of Family Member(s) with Sickness)") {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Mga pangalan na may sakit\n(List of Family Members With Sickness)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan",
            "Uri ng Sakit",
            "Edad",
            "Gender"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 4}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return (
            [
              {content: item.purok}, 
              {content: item.house_no}, 
              {content: item.street}, 
              {content: item.fullname}, 
              {content: item.sakit}, 
              {content: item.age}, 
              {content: item.sex}
            ]
          )
        }) : []

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 40, bottom: padding + 20},
          styles: {
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "left" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.15, halign: "left" }, // Street
            3: { cellWidth: pageWidth * 0.20, halign: "left" }, // Pangalan
            4: { cellWidth: pageWidth * 0.15, halign: "left" }, // Uri ng Sakit
            5: { cellWidth: pageWidth * 0.05, halign: "left" }, // Edad
            6: { cellWidth: pageWidth * 0.1, halign: "left" }, // Gender
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
        doc.line(40, pageHeight - 80, pageWidth - 50, pageHeight - 80);
      } else if (formName === "[5] Mga Miyembro ng Pamilya na walang Health Insurance (List of Family Members without Health Insurance)") {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Mga Miyembro ng Pamilya na walang Health Insurance\n(List of Family Members without Health Insurance)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan ng Puno ng Bahay",
            "Pangalan ng Miyembro ng Pamilya"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 4}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return (
            [
              {content: item.purok}, 
              {content: item.house_no}, 
              {content: item.street}, 
              {content: item.family_head}, 
              {content: item.family_member}
            ]
          )
        }) : []

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 60, bottom: padding + 20},
          styles: {
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "left" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.20, halign: "left" }, // Street
            3: { cellWidth: pageWidth * 0.20, halign: "left" }, // Pangalan
            4: { cellWidth: pageWidth * 0.20, halign: "left" }, // Uri ng Sakit
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === "[6] Mga Miyembro ng Pamilya na Mayroong Health Insurance (List of Family Members with Health Insurance)") {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Mga Miyembro ng Pamilya na Mayroong Health Insurance\n(List of Family Members wit Health Insurance)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan ng Puno ng Bahay",
            "Pangalan ng Miyembro ng Pamilya",
            "Uri ng Health Insurance",
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 4}],
        ];

        const parseData = () => {
          if (Object.keys(fetchedData).length === 0) return [];

          let prev_head = '';
          const items = [];
          for (let item of fetchedData) {
            if (item.family_head !== prev_head) {
              items.push([
                {content: item.purok},
                {content: item.house_no}, 
                {content: item.street}, 
                {content: item.family_head}, 
                {content: item.family_member}, 
                {content: item.insurance}
              ]);
              prev_head = item.family_head;
            } else {
              items.push([
                {content: ''},
                {content: ''}, 
                {content: ''}, 
                {content: ''}, 
                {content: item.family_member}, 
                {content: item.insurance}
              ]);
            }
          }

          return items;
        }

        const body = [
          ...parseData()
        ]

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 60, bottom: padding + 20},
          styles: {
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "left" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.15, halign: "left" }, // Street
            3: { cellWidth: pageWidth * 0.15, halign: "left" }, // Pangalan ng puno ng pamilya
            4: { cellWidth: pageWidth * 0.15, halign: "left" }, // Pangalan ng miyembro ng pamilya
            5: { cellWidth: pageWidth * 0.15, halign: "left" }, // Uri ng health insurance
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });

      } else if (formName === "[7] Mga Pamilyang may Batang hindi gumagamit ng Iodized salt (List of Families with Children not using Iodized salt)") {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng mga Pamilyang may Batang hindi gumagamit ng iodized salt\n(List of Families/Households with Children Not Using Iodized Salt)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan ng Puno ng Bahay",
            "Pangalan ng Bata"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 5}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => 
            [
              {content: item.purok}, 
              {content: item.house_no}, 
              {content: item.street}, 
              {content: item.family_head},
              {content: item.family_member}
            ]
        ) : [];

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 60, bottom: padding + 20},
          styles: {
            fontSize: 10, 
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.15, halign: "left" }, // Purok
            1: { cellWidth: pageWidth * 0.15, halign: "left" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.15, halign: "left" }, // Street
            3: { cellWidth: pageWidth * 0.175, halign: "left" }, // Pangalan ng puno ng pamilya
            4: { cellWidth: pageWidth * 0.175, halign: "left" }, // Pangalan ng puno ng pamilya
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === "[8] Listahan ng mga kasalukuyang Buntis (List of Pregnant Women)") {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng mga Buntis\n(List of Pregnant Women)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan",
            "Edad"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 4}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => 
          [
            {content: item.purok}, 
            {content: item.house_no}, 
            {content: item.street}, 
            {content: item.family_member}, 
            {content: item.age}
          ]
        ) : [];

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 60, bottom: padding + 20},
          styles: {
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.15, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.15, halign: "left" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.20, halign: "left" }, // Street
            3: { cellWidth: pageWidth * 0.20, halign: "left" }, // Pangalan
            4: { cellWidth: pageWidth * 0.10, halign: "center" } // Edad
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === "[9] Listahan ng mga bata edad 0-24 buwan ayon sa paraan ng pagpapakain (List of Children 0-24 monts according to feeding practices)") {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng mga Batang Kasalukuyang binibigyan ng Gatas ng Ina\n(List of Children Currently Breastfed)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan ng bata",
            "Kalagayan ng pagpapasuso",
            "Edad"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 6}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return (
            [
              {content: item.purok}, 
              {content: item.house_no}, 
              {content: item.street}, 
              {content: item.family_member}, 
              {content: item.feeding}, 
              {content: item.age}
            ]
          )
        }) : [];

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 60, bottom: padding + 20},
          styles: {
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "left" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "left" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.15, halign: "left" }, // Street
            3: { cellWidth: pageWidth * 0.20, halign: "left" }, // Pangalan ng bata
            4: { cellWidth: pageWidth * 0.15, halign: "left" }, // Kalagayan ng pagpapasuso
            5: { cellWidth: pageWidth * 0.10, halign: "left" } // Edad
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === "[10] Listahan ng mga batang pinurga at hindi napurga (List of Children Dewormed/not dewormed)") {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng mga Bata na Pinurga\n(List of Children Dewormed)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan",
            "Petsa ng huling pinurga",
            "Edad",
            "Gender"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 7}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return (
            [
              {content: item.purok},
              {content: item.house_no},
              {content: item.street},
              {content: item.family_member},
              {content: item.deworming_date},
              {content: item.age},
              {content: item.sex}
            ]
          )
        }) : []

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 60, bottom: padding + 20},
          styles: {
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.10, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.10, halign: "left" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.10, halign: "left" }, // Street
            3: { cellWidth: pageWidth * 0.15, halign: "left" }, // Pangalan ng bata
            4: { cellWidth: pageWidth * 0.15, halign: "center" }, // Petsa ng huling pinurga
            5: { cellWidth: pageWidth * 0.10, halign: "center" }, // Edad
            6: { cellWidth: pageWidth * 0.10, halign: "center" } // Gender
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === "[11] Listahan ng pamilya na hindi kumakain nang kaunti kaysa sa nararapat") {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng pamilya na hindi kumakain nang kaunti kaysa sa nararapat", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 70, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan ng Puno ng Pamilya"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 4}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return (
            [
              {content: item.purok},
              {content: item.house_no},
              {content: item.street},
              {content: item.fullname}
            ]
          )
        }): []

        autoTable(doc, {
          startY: 90,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 60, bottom: padding + 20},
          styles: {
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.15, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.15, halign: "center" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.25, halign: "center" }, // Street
            3: { cellWidth: pageWidth * 0.25, halign: "left" }, // Pangalan ng puno ng pamilya
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === "[12] Listahan ng mga batang edad 0-11 buwan na walang bakuna") {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng mga Batang Walang Bakuna (0-11 buwan)\n(List of Children without immunization (0-11 months))", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan",
            "Petsa ng Kapanganakan",
            "Edad (mos)",
            "Gender"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 7}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return [
            {content: item.purok},
            {content: item.house_no},
            {content: item.street},
            {content: item.fullname},
            {content: item.birthdate},
            {content: item.age},
            {content: item.gender},
          ]
        }) : []

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 60, bottom: padding + 20},
          styles: {
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "left" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "left" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.15, halign: "left" }, // Street
            3: { cellWidth: pageWidth * 0.15, halign: "left" }, // Pangalan
            4: { cellWidth: pageWidth * 0.1, halign: "left" }, // Petsa ng Kapanganakan
            5: { cellWidth: pageWidth * 0.1, halign: "left" }, // Edad (months)
            6: { cellWidth: pageWidth * 0.1, halign: "left" }, // Gender
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === "[13] Listahan ng mga batang edad 0-11 buwan na kasalukuyang binabakunahan") {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng mga Batang Kasalukuyang Binabakunahan (0-11 buwan)\n(List of Children currently immunize (0-11 months))", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan",
            "Petsa ng Kapanganakan",
            "Edad (mos)",
            "Gender",
            "Vaccine Received"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 7}],
        ];

        const getVaccineNames = (vaccineString) => {
          const vaccineMapping = {
            "1" : "BCG",
            "2" : "HepatitisB",
            "3" : "Pentavalent",
            "4" : "OPV",
            "5" : "IPV",
            "6" : "PCV",
            "7" : "MMR",
            "8" : "Others"
          }
          let vaccineNames = '';
          const vaccineIds = vaccineString.split(",");
          for (let vax of vaccineIds) {
            vaccineNames += `${vaccineMapping[vax]} `
          }
          return vaccineNames;
        }

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return [
            {content: item.purok},
            {content: item.house_no},
            {content: item.street},
            {content: item.fullname},
            {content: item.birthdate},
            {content: item.age},
            {content: item.gender},
            {content: getVaccineNames(item.vaccines_received_primary)}
          ]
        }) : []

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 40, bottom: padding + 20},
          styles: {
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.08, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.08, halign: "left" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.1, halign: "left" }, // Street
            3: { cellWidth: pageWidth * 0.15, halign: "left" }, // Pangalan
            4: { cellWidth: pageWidth * 0.08, halign: "left" }, // Petsa ng Kapanganakan
            5: { cellWidth: pageWidth * 0.08, halign: "left" }, // Edad (months)
            6: { cellWidth: pageWidth * 0.08, halign: "left" }, // Gender
            7: { cellWidth: pageWidth * 0.20, halign: "left" }, // Vacines Received
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === "[14] Listahan ng mga batang edad 12-23 buwan na wala o hindi kumpleto and bakuna") {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng mga batang wala o hindi kompleto ang bakuna (12-23 buwan)\n(List of Children without or incomplete immunization (12-23 months))", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan",
            "Petsa ng Kapanganakan",
            "Edad (mos)",
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 6}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return [
            {content: item.purok},
            {content: item.house_no},
            {content: item.street},
            {content: item.fullname},
            {content: item.birthdate},
            {content: item.age}
          ]
        }) : []

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 65, bottom: padding + 20},
          styles: {
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "left" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.15, halign: "left" }, // Street
            3: { cellWidth: pageWidth * 0.20, halign: "left" }, // Pangalan
            4: { cellWidth: pageWidth * 0.15, halign: "center" }, // Petsa ng Kapanganakan
            5: { cellWidth: pageWidth * 0.1, halign: "center" }, // Edad (months)
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === "[15] Listahan ng mga tao ayon sa kalagayan ng COVID Vaccination") {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Mga Pangalan ayon sa COVID Vaccination Status\n(List of Family Members according to COVID Vaccination)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan",
            "Kalagayan",
            "Edad",
            "Gender",
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 7}],
        ];

        const body = []

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 65, bottom: padding + 20},
          styles: {
            fontSize: 10,
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "left" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.1, halign: "left" }, // Street
            3: { cellWidth: pageWidth * 0.15, halign: "left" }, // Pangalan
            4: { cellWidth: pageWidth * 0.15, halign: "center" }, // Kalagayan
            5: { cellWidth: pageWidth * 0.1, halign: "center" }, // Edad
            6: { cellWidth: pageWidth * 0.1, halign: "center"} // Gender
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      }
    } else if (reportType === "Institutional Household, Death, and Migration Profile") {
      // reports
      if (formName === "[1] Listahan ng mga Hindi Residente sa Barangay") {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng mga Hindi Residente\n(List of Non-Residents)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan",
            "Kasarian",
            "Edad",
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 6}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return [
            {content: item.purok},
            {content: item.house_no},
            {content: item.street},
            {content: item.fullname},
            {content: item.sex},
            {content: item.age}
          ]
        }) : []

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 50, bottom: padding + 20},
          styles: {
            fontSize: 10,
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "left" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "left" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.15, halign: "left" }, // Street
            3: { cellWidth: pageWidth * 0.20, halign: "left" }, // Pangalan
            4: { cellWidth: pageWidth * 0.15, halign: "center" }, // Kasarian
            5: { cellWidth: pageWidth * 0.15, halign: "center"} // Edad
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === "[2] Listahan ng mga umalis sa Barangay") {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng mga Umalis sa Barangay\n(List of Inactive Barangay Members)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan",
            "Kasarian",
            "Edad",
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 6}],
        ];

        const parseData = () => {
          if (Object.keys(fetchedData).length === 0) return [];
          const items = [];
          let prev_rel = '';
          for (let item of fetchedData) {
            if (item.relationship != prev_rel) {
              items.push(
                [{content: `Mga ${item.relationship}`, styles: {fontStyle: "bold", cellPadding: {left: 10, top:5, bottom: 5}, halign: "left"}, colSpan: 6}]
              );
              prev_rel = item.relationship;
            }
            items.push(
              [
                {content: item.purok}, 
                {content: item.house_no}, 
                {content: item.street}, 
                {content: item.family_member}, 
                {content: item.sex}, 
                {content: item.age}
              ]
            )
          }

          return items;

        }

        const body = [
          ...parseData()  
        ]

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 70, bottom: padding + 20},
          styles: {
            fontSize: 10,
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "left" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.15, halign: "left" }, // Street
            3: { cellWidth: pageWidth * 0.20, halign: "left" }, // Pangalan
            4: { cellWidth: pageWidth * 0.1, halign: "center" }, // Kasarian
            5: { cellWidth: pageWidth * 0.1, halign: "center"} // Edad
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
        doc.line(70, pageHeight - 80, pageWidth - 80, pageHeight - 80);
      } else if (formName === "[3] Listahan ng mga namatay sa Barangay") {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Mga pangalan na mga namatay\n(List of Family Members Died)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Numero ng Bahay",
            "Street",
            "Pangalan",
            "Dahilan ng Pagkamatay",
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 5}],
        ];

        const parseData = () => {
          if (Object.keys(fetchedData).length === 0) return [];
          const items = [];
          let prev_purok = '';
          let prev_year = '';
          for (let item of fetchedData) {
            if (item.purok !== prev_purok) {
              items.push(
                [{content: `Purok: ${item.purok}`, styles: {fontStyle: "bolditalic", cellPadding: {left: 10, top:5, bottom: 5}, halign: "left"}, colSpan: 5}]
              );
              prev_purok = item.purok;
              prev_year = '';
            }

            if (item.death_year !== prev_year) {
              items.push(
                [{content: `Year: ${item.death_year}`, styles: {fontStyle: "bolditalic", cellPadding: {left: 30, top:5, bottom: 5}, halign: "left"}, colSpan: 5}]
              )
              prev_year = item.death_year;
            }

            items.push(
              [
                {content: item.house_no}, 
                {content: item.street}, 
                {content: item.family_member}, 
                {content: item.sakit}, 
              ]
            )
          }

          return items;
        }

        const body = [
          ...parseData()
         ]

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 80, bottom: padding + 20},
          styles: {
            fontSize: 10,
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.15, halign: "center" }, // Numero ng Bahay
            1: { cellWidth: pageWidth * 0.15, halign: "left" }, // Street
            2: { cellWidth: pageWidth * 0.20, halign: "left" }, // Pangalan
            3: { cellWidth: pageWidth * 0.20, halign: "left" }, // Dahilan ng Pagkamatay
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      }
    } else if (reportType === "Socio-economic Profile") {
      // reports
      if (formName === "[1] Listahan ng mga pamilya (Masterlist of Families)") {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng mga Pamilya\n(Masterlist)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan ng Puno ng Pamilya",
            "May-ari/Kapisan",
            "Head ID of Main family",
            "Mga Miyembro ng Pamilya",
            "Age"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 8}],
        ];

        const parseData = () => {
          if (Object.keys(fetchedData).length === 0) return []
          const items = [];
          let prev_head = '';

          for (let item of fetchedData) {
            if (item.family_head !== prev_head) {
              items.push(
                [
                  {content: item.purok}, 
                  {content: item.house_no}, 
                  {content: item.street}, 
                  {content: item.family_head}, 
                  {content: item.family_type}, 
                  {content: item.head_id}, 
                  {content: item.family_member}, 
                  {content: item.age}
                ]
              );
              prev_head = item.family_head;
            } else {
              items.push(
                [
                  {content: ''}, 
                  {content: ''}, 
                  {content: ''}, 
                  {content: ''}, 
                  {content: ''}, 
                  {content: ''}, 
                  {content: item.family_member}, 
                  {content: item.age}
                ]
              );
            }
          }

          return items;
        }

        const body = [
          ...parseData()
        ]

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 40, bottom: padding + 10},
          styles: {
            fontSize: 10,
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.08, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.08, halign: "left" }, // Numbero ng Bahay
            2: { cellWidth: pageWidth * 0.1, halign: "left" }, // Street
            3: { cellWidth: pageWidth * 0.20, halign: "center" }, // Pangalang ng Puno ng Pamilya
            4: { cellWidth: pageWidth * 0.08, halign: "center" }, // May-ari/Kapisan
            5: { cellWidth: pageWidth * 0.08, halign: "center" }, // Head ID of Main Family
            6: { cellWidth: pageWidth * 0.15, halign: "left" }, // Mga miyembro ng pamilya
            7: { cellWidth: pageWidth * 0.08, halign: "right" }, // Age
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === "[2a] Listahan ng mga walang pirmihang hanapbuhay (Without Regular Income) - Puno ng Pamilya") {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng puno pamilya na walang regular na hanapbuhay\n(List of Head of Families Without Regular Income)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan ng Puno ng Pamilya",
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 4}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return (
            [
              {content: item.purok}, 
              {content: item.house_no}, 
              {content: item.street}, 
              {content: item.fullname}
            ]
          )
        }) : [];

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 60, bottom: padding + 20},
          styles: {
            fontSize: 10,
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.15, halign: "left" }, // Numbero ng Bahay
            2: { cellWidth: pageWidth * 0.25, halign: "left" }, // Street
            3: { cellWidth: pageWidth * 0.30, halign: "left" }, // Pangalang ng Puno ng Pamilya
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === "[2b] Listahan ng mga walang pirmihang hanapbuhay (Without Regular Income) - Asawa ng Puno ng Pamilya") {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Mga asawa na walang hanapbuhay at regular na hanapbuhay\n(List of Spouses W/o Source of Income and W/o Regular Income)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan ng Asawa",
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 4}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return (
            [
              {content: item.purok}, 
              {content: item.house_no}, 
              {content: item.street}, 
              {content: item.fullname}
            ]
          )
        }) : [];

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 60, bottom: padding + 20},
          styles: {
            fontSize: 10,
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.15, halign: "left" }, // Numbero ng Bahay
            2: { cellWidth: pageWidth * 0.25, halign: "left" }, // Street
            3: { cellWidth: pageWidth * 0.30, halign: "left" }, // Pangalang ng Puno ng Pamilya
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === '[3a] Listahan ng pamilyang mababa ang "per capita income" - below food threshold') {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "List of Households with per capita income below food threshold)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 60, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan ng Puno ng Pamilya",
            "per capita income"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 4}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return ([
            {content: item.purok},
            {content: item.house_no},
            {content: item.street},
            {content: item.fullname},
            {content: item.family_income}
          ])
        }) : [];

        autoTable(doc, {
          startY: 80,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 60, bottom: padding + 20},
          styles: {
            fontSize: 10,
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "left" }, // Numbero ng Bahay
            2: { cellWidth: pageWidth * 0.15, halign: "left" }, // Street
            3: { cellWidth: pageWidth * 0.25, halign: "left" }, // Pangalang ng Puno ng Pamilya
            4: { cellWidth: pageWidth * 0.2, halign: "center"}, // per capita income
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === '[3b] Listahan ng pamilyang mababa ang "per capita income" - above food threshold but below poverty') {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "List of Households with per capita income below poverty\nthreshold but above food threshold)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan ng Puno ng Pamilya",
            "per capita income"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 4}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return ([
            {content: item.purok},
            {content: item.house_no},
            {content: item.street},
            {content: item.fullname},
            {content: item.family_income}
          ])
        }) : [];

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 60, bottom: padding + 20},
          styles: {
            fontSize: 10,
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "left" }, // Numbero ng Bahay
            2: { cellWidth: pageWidth * 0.15, halign: "left" }, // Street
            3: { cellWidth: pageWidth * 0.25, halign: "left" }, // Pangalang ng Puno ng Pamilya
            4: { cellWidth: pageWidth * 0.2, halign: "center"}, // per capita income
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === '[4] Mga miyembro ng pamilya na naghahanapbuhay (List of Family Member(s) with Source of Income)') {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Mga miyembro ng pamilya na may hanapbuhay\n(List of Household Members With Source of Income)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan",
            "Pangunahing Hanapbuhay (Pirmihan/Di Pirmihan)",
            "Ibang Hanapbuhay"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 6}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return (
            [
              {content: item.purok}, 
              {content: item.house_no}, 
              {content: item.street}, 
              {content: item.fullname}, 
              {content: item.trabaho}, 
              {content: item.ibang_hanapbuhay}
            ]
          )
        }) : []

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 60, bottom: padding + 20},
          styles: {
            fontSize: 10,
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "left" }, // Numbero ng Bahay
            2: { cellWidth: pageWidth * 0.15, halign: "left" }, // Street
            3: { cellWidth: pageWidth * 0.15, halign: "left" }, // Pangalan
            4: { cellWidth: pageWidth * 0.15, halign: "left"}, // per capita income
            5: { cellWidth: pageWidth * 0.15, haligh: "left"}, // Ibang hanapbuhay
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === '[5] Mga miyembro ng pamilya na naghahanapbuhay ayon sa kurso at kita (List of Family Member(s) with Source of Income/Course/Income)') {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng mga miyembro ng pamilya na may hanapbuhay\nayon sa kurso ng natapos na kita\n(List of Household Members With Source of Income based on course and income)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 90, { align: "center" });

        const head = [
          [
            "Purok",
            "Pangalan",
            "Pangunahing Hanapbuhay",
            "Ibang Hanapbuhay",
            "Kurso",
            "Kita"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 6}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return (
            [
              {content: item.purok}, 
              {content: item.fullname}, 
              {content: item.trabaho}, 
              {content: item.ibang_hanapbuhay}, 
              {content: item.degree}, 
              {content: item.monthly_income}
            ]
          )
        }) : []

        autoTable(doc, {
          startY: 120,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 60, bottom: padding + 20},
          styles: {
            fontSize: 10,
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.15, halign: "left" }, // Pangalan
            2: { cellWidth: pageWidth * 0.15, halign: "left"}, // Pangunahing hanapbuhay
            3: { cellWidth: pageWidth * 0.15, haligh: "left"}, // Ibang hanapbuhay
            4: { cellWidth: pageWidth * 0.15, halign: "left"}, // Kurso
            5: { cellWidth: pageWidth * 0.1, halign: "left"}, // Kita

          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === '[6] Mga miyembro ng pamilya na naghahanapbuhay sa ibang bansa (List of Overseas Filipino Workers') {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Mga miyembro ng pamilya na mga Overseas Filipino Workers (OFW)\n(List of Household Members who are Overseas Filipino Workers (OFW)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan",
            "Hanapbuhay",
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 5}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return [
            {content: item.purok}, 
            {content: item.house_no}, 
            {content: item.street}, 
            {content: item.fullname}, 
            {content: item.trabaho}
          ]
        }) : []

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 60, bottom: padding + 20},
          styles: {
            fontSize: 10,
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.15, halign: "left" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.15, halign: "left"}, // Street
            3: { cellWidth: pageWidth * 0.2, haligh: "left"}, // Pangalan
            4: { cellWidth: pageWidth * 0.2, halign: "left"}, // Hanapbuhay

          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === '[7] Listahan ng mga kabataan na hindi napasok sa paaralan (Children not attending school)') {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng mga kabataan na hindi na napasok sa paaralan\n(List of Children not attending school)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Pangalan ng Puno ng Pamilya",
            "Pangalan ng Bata",
            "Date of Birth",
            "Edad"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 6}],
        ];

        const parseData = () => {
          if (Object.keys(fetchedData).length === 0) return [];
          const items = [];
          let prev_antas = ''
          for (let item of fetchedData) {
            if (item.antas !== prev_antas) {
              prev_antas = item.antas;
              items.push([
                {content: item.antas, styles: {fontStyle: "bolditalic", halign: 'left'}, colSpan: 6}
              ])
            }

            items.push([
              {content: item.purok}, 
              {content: item.house_no}, 
              {content: item.headname}, 
              {content: item.childname}, 
              {content: item.birthdate}, 
              {content: item.age}
            ])
          }
          return items;
        }

        const body = [
          ...parseData()
        ]

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 60, bottom: padding + 20},
          styles: {
            fontSize: 10,
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.15, halign: "center" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.15, halign: "center"}, // Pangalan ng Puno ng Pamilya
            3: { cellWidth: pageWidth * 0.15, haligh: "center"}, // Pangalan ng Bata
            4: { cellWidth: pageWidth * 0.15, halign: "center"}, // Date of Birth
            5: { cellWidth: pageWidth * 0.1, halign: "center"}, // Edad

          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === '[8] Mga miyembro ng pamilya na may kasanayan/kakayahan (List of Skilled Workers)') {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Mga Pangalan na may sariling kasanayan/kakayahan\n(List of Skilled Workers)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan",
            "Kakayahan/Kasanayan"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 5}],
        ];

        const parseData = () => {
          if (Object.keys(fetchedData).length === 0) return [];
          const items = [];
          let prev_name = ""

          for (let item of fetchedData) {
            if (item.fullname !== prev_name) {
              items.push(
                [
                  {content: item.purok}, 
                  {content: item.house_no}, 
                  {content: item.street}, 
                  {content: item.fullname}, 
                  {content: item.Skills}
                ]
              )
              prev_name = item.fullname;
            } else {
              items.push(
                [
                  {content: ""}, 
                  {content: ""}, 
                  {content: ""}, 
                  {content: item.fullname}, 
                  {content: item.Skills}
                ]
              )
            }
          }

          return items;
        }

        const body = [
          ...parseData()
        ]

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 60, bottom: padding + 20},
          styles: {
            fontSize: 10,
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.15, halign: "left" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.15, halign: "left"}, // Street
            3: { cellWidth: pageWidth * 0.2, haligh: "left"}, // Pangalan
            4: { cellWidth: pageWidth * 0.2, halign: "left"}, // Kakayahan/Kasanayan

          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === '[9] Mga botanteng rehistrado sa barangay edad 18 taong gulang pataas') {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng mga Botanteng Rehistrado sa Barangay\n(List of Registered Voters)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan",
            "Edad"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 5}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return (
            [
              {content: item.purok}, 
              {content: item.house_no}, 
              {content: item.street}, 
              {content: item.fullname}, 
              {content: item.age}
            ]
          )
        }) : []

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 60, bottom: padding + 20},
          styles: {
            fontSize: 10,
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "left" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.15, halign: "left"}, // Street
            3: { cellWidth: pageWidth * 0.2, haligh: "left"}, // Pangalan
            4: { cellWidth: pageWidth * 0.25, halign: "center"}, // Edad

          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === '[10] Mga botanteng hindi rehistrado sa barangay edad 18 taong gulang pataas') {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng mga Botanteng Hindi Rehistrado sa Barangay\n(List of Unregistered Voters)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan",
            "Edad"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 5}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return (
            [
              {content: item.purok},
              {content: item.house_no},
              {content: item.street},
              {content: item.fullname},
              {content: item.age}
            ]
          )
        }) : []

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 60, bottom: padding + 20},
          styles: {
            fontSize: 10,
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "left" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.15, halign: "left"}, // Street
            3: { cellWidth: pageWidth * 0.2, haligh: "left"}, // Pangalan
            4: { cellWidth: pageWidth * 0.25, halign: "center"}, // Edad

          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === '[11] Mga botanteng kabataan edad 15-17 taong gulang (List of SK Votees)') {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng mga Sanggunian Kabataan na may edad 15-17 taong gulang\n(List of SK Votees)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan",
            "Edad"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 5}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return (
            [
              {content: item.purok},
              {content: item.house_no},
              {content: item.street},
              {content: item.fullname},
              {content: item.age}
            ]
          )
        }) : []

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 60, bottom: padding + 20},
          styles: {
            fontSize: 10,
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "left" }, // Numero ng Bahay
            2: { cellWidth: pageWidth * 0.15, halign: "left"}, // Street
            3: { cellWidth: pageWidth * 0.2, haligh: "left"}, // Pangalan
            4: { cellWidth: pageWidth * 0.25, halign: "center"}, // Edad

          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === '[12] Mga miyembro ng pamilya na hindi naka-rehistro sa "Local Civil Registrar" (List of Unregistered Live Births at the Local Civil Registrar)') {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng Hindi Rehistrado sa Municipal/Local Civil Registrar", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 60, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan",
            "Edad"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 4}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return [
            {content: item.purok},
            {content: item.house_no},
            {content: item.street},
            {content: item.fullname},
            {content: item.age}
          ]
        }) : []

        autoTable(doc, {
          startY: 80,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 60, bottom: padding + 20},
          styles: {
            fontSize: 10,
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "left" }, // Numbero ng Bahay
            2: { cellWidth: pageWidth * 0.1, halign: "left" }, // Street
            3: { cellWidth: pageWidth * 0.25, halign: "left" }, // Pangalang ng Puno ng Pamilya
            4: { cellWidth: pageWidth * 0.25, halign: "center"}, // per capita income
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === '[13] Mga Senior Citizen edad 60 taong gulang pataas (List of Senior Citizen)') {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng mga Senior Citizen\n(List of Senior Citizen)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan",
            "Senior ID",
            "Kaarawan",
            "Edad"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 7}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return (
            [
              {content: item.purok}, 
              {content: item.house_no}, 
              {content: item.street}, 
              {content: item.fullname}, 
              {content: item.senior_citizen_id}, 
              {content: item.birthdate}, 
              {content: item.age}
            ]
          )
        }) : []

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 60, bottom: padding + 20},
          styles: {
            fontSize: 10,
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "left" }, // Numbero ng Bahay
            2: { cellWidth: pageWidth * 0.1, halign: "left" }, // Street
            3: { cellWidth: pageWidth * 0.2, halign: "left" }, // Pangalang
            4: { cellWidth: pageWidth * 0.1, halign: "center"}, // Senior ID
            5: { cellWidth: pageWidth * 0.1, halign: "left" }, // Kaarawan
            6: { cellWidth: pageWidth * 0.1, halign: "center"}, // Edad
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === '[14] Mga may-ari ng sasakyan (List of Families with Vehicles)') {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng mga pamilya na may pagmamay-ari ng sasakyan\n(List of Families with Vehicles)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan ng Puno ng Pamilya",
            "Uri ng Sasakyan",
            "Bilang"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 6}],
        ];

        const parseData = () => {
          if (Object.keys(fetchedData).length === 0) return [];
          const items = [];
          let prev_head = ''
          for (let item of fetchedData) {
            if (item.fullname !== prev_head) {
              items.push([
                {content: item.purok},
                {content: item.house_no},
                {content: item.street},
                {content: item.fullname},
                {content: item.vehicle},
                {content: item.quantity}
              ])
              prev_head = item.fullname
            } else {
              items.push([
                {content: ''},
                {content: ''},
                {content: ''},
                {content: ''},
                {content: item.vehicle},
                {content: item.quantity}
              ])
            }
          }

          return items;
        }

        const body = [
          ...parseData()
         ]

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 60, bottom: padding + 20},
          styles: {
            fontSize: 10,
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "left" }, // Numbero ng Bahay
            2: { cellWidth: pageWidth * 0.1, halign: "left" }, // Street
            3: { cellWidth: pageWidth * 0.25, halign: "left" }, // Pangalan ng Puno ng Pamilya
            4: { cellWidth: pageWidth * 0.15, halign: "left"}, // Uri ng Sasakyan
            5: { cellWidth: pageWidth * 0.1, halign: "right" }, // Bilang
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === '[15] Mga pamilyang mayroong Telepono (List of Families with Telephones)') {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng pamilya na may pagmamay-ari ng telepono\n(List of Families With Telephones)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan ng Puno ng Pamilya",
            "Linya ng Telepono",
            "Numero"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 6}],
        ];

        const parseData = () => {
          if (Object.keys(fetchedData).length === 0) return [];
          const items = [];
          const prev_name = ''
          for (let item of fetchedData) {
            if (item.fullname !== prev_name) {
              items.push(
                [
                  {content: item.purok},
                  {content: item.house_no},
                  {content: item.street},
                  {content: item.fullname},
                  {content: item.provider},
                  {content: item.number}
                ]
              )
            } else {
              items.push(
                [
                  {content: ''},
                  {content: ''},
                  {content: ''},
                  {content: ''},
                  {content: item.provider},
                  {content: item.number}
                ]
              )
            }
          }

          return items;
        }

        const body = [
          ...parseData()
        ]

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 60, bottom: padding + 20},
          styles: {
            fontSize: 10,
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "left" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "left" }, // Numbero ng Bahay
            2: { cellWidth: pageWidth * 0.1, halign: "left" }, // Street
            3: { cellWidth: pageWidth * 0.25, halign: "left" }, // Pangalan ng Puno ng Pamilya
            4: { cellWidth: pageWidth * 0.1, halign: "left"}, // Linya ng Telepono
            5: { cellWidth: pageWidth * 0.15, halign: "left" }, // Numero
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === '[16] Mga pamilya na mayroon internet connectivity (List of Families with internet connectivity)') {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng pamilya na may internet connectivity\n(List of Families With Internet Connectivity)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan ng Puno ng Pamilya",
            "Linya ng Internet",
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 5}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return (
            [
              {content: item.purok},
              {content: item.house_no},
              {content: item.street},
              {content: item.fullname},
              {content: item.provider},
            ]
          )
        }) : [];

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 60, bottom: padding + 20},
          styles: {
            fontSize: 10,
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "left" }, // Numbero ng Bahay
            2: { cellWidth: pageWidth * 0.15, halign: "left" }, // Street
            3: { cellWidth: pageWidth * 0.25, halign: "left" }, // Pangalan ng Puno ng Pamilya
            4: { cellWidth: pageWidth * 0.2, halign: "left"}, // Linya ng Internet
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === '[17] Mga miyembro ng pamilya na kasapi sa mga organisasyon (List of Family member(s) based on Membership in Organization)') {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng Miyembro ng Pamilya na Sumali sa mga Organisasyon\n(List of Family Member(s) based on Membership on Organizations)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan",
            "Organisasyon",
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 5}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return (
            [
              {content: item.purok}, 
              {content: item.house_no}, 
              {content: item.street}, 
              {content: item.fullname}, 
              {content: item.org}
            ]
          )
        }) : []

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 60, bottom: padding + 20},
          styles: {
            fontSize: 10,
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "left" }, // Numbero ng Bahay
            2: { cellWidth: pageWidth * 0.15, halign: "left" }, // Street
            3: { cellWidth: pageWidth * 0.25, halign: "left" }, // Pangalan
            4: { cellWidth: pageWidth * 0.2, halign: "left"}, // Organisasyon
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } else if (formName === '[18] Mga miyembro ng pamilya na Solo Parent, Widow, Separated, Annulled and Legally Separated') {
        doc.setFontSize(12);
        doc.setFont("times", "bold")
        doc.text(
          "Listahan ng mga Solo Parents, Widow at Separated\n(List of Solo Parents, Widow, and Separated)", 
          pageWidth / 2,
          50,
          { align: "center" }
        );

        const dateToday = getCurrentDate();
        doc.setFontSize(10);
        doc.text(dateToday, pageWidth / 2, 80, { align: "center" });

        const head = [
          [
            "Purok",
            "Numero ng Bahay",
            "Street",
            "Pangalan",
            "Solo Parent ID",
            "Kaarawan",
            "Edad"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 7}],
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return (
            [
              {content: item.purok}, 
              {content: item.house_no}, 
              {content: item.street}, 
              {content: item.fullname}, 
              {content: item.solo_parent_id}, 
              {content: item.birthdate}, 
              {content: item.age}
            ]
          )
        }) : [];

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          margin: {left: 60, bottom: padding + 20},
          styles: {
            fontSize: 10,
            cellPadding: 2,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: pageWidth * 0.1, halign: "center" }, // Purok
            1: { cellWidth: pageWidth * 0.1, halign: "left" }, // Numbero ng Bahay
            2: { cellWidth: pageWidth * 0.1, halign: "left" }, // Street
            3: { cellWidth: pageWidth * 0.15, halign: "left" }, // Pangalan
            4: { cellWidth: pageWidth * 0.15, halign: "left"}, // Solo Parent ID
            5: { cellWidth: pageWidth * 0.1, halign: "left" }, // Kaarawan
            6: { cellWidth: pageWidth * 0.1, halign: "center"}, // Edad
          },
          didParseCell: function (data) {
            // Only apply to the first column of the Barangay row (row index 1)
            if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fillColor = [211,211,211];
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = {
                top: 6,
                right: 4,
                bottom: 6,
                left: 5,
              };
              data.cell.styles.lineWidth = {
                top: 2
              };
              data.cell.styles.lineColor = BLUE;
            }
          },
        });
      } 
    }

    // Page Numbering
    doc.setFontSize(8);
    doc.setFont("times", "bolditalic");
    doc.setTextColor(0, 0, 125);
    const pageCount = doc.internal.getNumberOfPages();
    const currentDate = getCurrentDate();

    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);

      const text = `Page ${i} of ${pageCount}`;
      const textWidth = doc.getTextWidth(text);

      doc.text(text, pageWidth - textWidth - padding, pageHeight - padding, {align: "left"});
      doc.text(currentDate, padding, pageHeight - padding, {align: "left"});
    }

    return doc;
  };

  const handleViewDownload = async (reportType, selectedForm, actionType) => {
    if (!isSearchApplied) {
      alert('Please click "Apply Search" first to enable report actions.');
      return;
    }
    if (!selectedForm) {
      alert(`Please select a form for ${reportType} before ${actionType}.`);
      return;
    }

    // locationData is already available from props
    const doc = await generateForm(reportType, selectedForm, locationData);
    const { provinceName, municipalName, barangayName } = locationData; // Redundant destructuring but harmless

    if (actionType === "view") {
      doc.output("dataurlnewwindow");
    } else if (actionType === "download") {
      const filename = `${barangayName}_${municipalName}_${provinceName}`;
      doc.save(
        `${selectedForm.replace(/\s+/g, "_")}_${filename.replace(
          /\s+/g,
          "_"
        )}.pdf`
      );
    }
  };

  const reportCategories = [
    {
      name: "Agriculture and Fishery Profile",
      state: selectedAgricultureForm,
      setter: setSelectedAgricultureForm,
    },
    {
      name: "Disaster Risk Reduction Profile",
      state: selectedDisasterForm,
      setter: setSelectedDisasterForm,
    },
    {
      name: "Environmental Sanitation",
      state: selectedEnvironmentalForm,
      setter: setSelectedEnvironmentalForm,
    },
    {
      name: "Health and Nutrition Profile",
      state: selectedHealthNutritionForm,
      setter: setSelectedHealthNutritionForm,
    },
    {
      name: "Institutional Household, Death, and Migration Profile",
      state: selectedInstitutionalForm,
      setter: setSelectedInstitutionalForm,
    },
    {
      name: "Socio-economic Profile",
      state: selectedSocioEconomicForm,
      setter: setSelectedSocioEconomicForm,
    },
    {
      name: "Peace and Order Profile",
      state: selectedPeaceOrderForm,
      setter: setSelectedPeaceOrderForm,
    },
  ];

  const disabledButtonStyles = {
    backgroundColor: "#cccccc",
    cursor: "not-allowed",
    color: "#666666",
  };

  return (
    <div style={pageContainer}>
      {/* Removed local search input and apply search button */}
      <div style={reportContainer}>
        <h2 style={heading}>Generate Reports</h2>

        <div style={reportCardsContainer}>
          {reportCategories.map((category, index) => (
            <div key={index} style={card}>
              <h3>{category.name}</h3>
              <div style={{ marginBottom: "15px" }}>
                <label
                  htmlFor={`select-form-${index}`}
                  style={{ marginRight: "10px", fontSize: "16px" }}
                >
                  Select Form:
                </label>
                <select
                  id={`select-form-${index}`}
                  value={category.state}
                  onChange={(e) => category.setter(e.target.value)}
                  style={{
                    padding: "8px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    width: "150px",
                  }}
                  disabled={!isSearchApplied} // Disable dropdown if search not applied
                >
                  <option value="">-- Select --</option>
                  {formOptions[category.name].map((option, idx) => (
                    <option key={idx} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
              <button
                onClick={() =>
                  handleViewDownload(category.name, category.state, "view")
                }
                style={{
                  ...button,
                  marginRight: "10px",
                  ...(!isSearchApplied || !category.state
                    ? disabledButtonStyles
                    : {}),
                }}
                disabled={!isSearchApplied || !category.state}
              >
                View
              </button>
              <button
                onClick={() =>
                  handleViewDownload(category.name, category.state, "download")
                }
                style={{
                  ...button,
                  ...(!isSearchApplied || !category.state
                    ? disabledButtonStyles
                    : {}),
                }}
                disabled={!isSearchApplied || !category.state}
              >
                Download
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// Styling (reused from MultiReportPage for consistency)
const pageContainer = {
  // Removed marginTop as Header is now in parent
  minHeight: "calc(100vh - 0px)", // Adjusted minHeight
  backgroundColor: "#f8f9fa",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%", // Ensure it takes full width of parent
};

const reportContainer = {
  width: "100%", // Adjusted to fill parent's width
  backgroundColor: "#ffffff",
  padding: "30px",
  borderRadius: "10px",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
};

const heading = {
  fontSize: "24px",
  fontWeight: "bold",
  marginBottom: "20px",
  textAlign: "center",
  color: "#333",
};

const reportCardsContainer = {
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  gap: "20px",
};

const card = {
  marginBottom: "20px",
  padding: "15px",
  border: "1px solid #ddd",
  borderRadius: "8px",
  backgroundColor: "#fefefe",
  boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
  flex: "1 1 calc(33% - 40px)", // Adjusted for 3 cards per row on larger screens
  minWidth: "280px",
  maxWidth: "calc(33% - 20px)", // Adjusted for 3 cards per row on larger screens
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
};

const button = {
  padding: "10px 20px",
  backgroundColor: "#007bff",
  color: "#fff",
  border: "none",
  borderRadius: "5px",
  fontWeight: "bold",
  cursor: "pointer",
  marginTop: "10px",
  transition: "background-color 0.3s ease",
};

const disabledButtonStyles = {
  backgroundColor: "#cccccc",
  cursor: "not-allowed",
  color: "#666666",
};

export default Reports;
